import React, { useCallback, useState } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useTranslations } from 'js/hooks/i18n';
import { useAppSelector } from 'js/store/hooks';
import { AccessibilityElement } from 'js/components/common/AccessibilityElement';

import * as hooks from './hooks';

import style from './FavoriteIcon.scss';

// The IMG here is a 1x1px transparent image with 1:1 intrinsic aspect ratio. This image is used as container for
// actual image put in its background and it is able to resize maintaining aspect ratio based on *height* without JS.
// Image taken from
// http://stackoverflow.com/questions/6018611/smallest-data-uri-image-possible-for-a-transparent-image
export const FavoriteIcon = ({
    gameFeed,
    className = '',
    code,
    isFeatured = false
}) => {
    const translate = useTranslations('playtech.mobile.system.favorite.game.');
    const favoriteGames = useAppSelector(prop('favoriteGames')) || [];
    const isFavorite = favoriteGames.includes(code);
    const [afterToggleInfo, setAfterToggleInfo] = useState('');
    const [toggleInfo, setToggleInfo] = useState(translate('icon.aria-label'));
    const toggleFavorite = hooks.useToggleFavorite({ code, isFavorite, gameFeed, translate, setAfterToggleInfo });
    const activeClassName = isFavorite ? style.on : '';

    const onClick = useCallback((event) => {
        event.stopPropagation();
        event.preventDefault();

        setToggleInfo('');
        toggleFavorite();
    }, [toggleFavorite]);

    const onBlur = useCallback(() => {
        setToggleInfo(translate('icon.aria-label'));
    }, [translate]);

    return (
        <div className={`${style.wrapper} ${className}`}>
            <img
                className={`${style.icon} ${isFeatured ? style.featured : ''} ${activeClassName}`}
                src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                alt='favorite'
                aria-hidden={true}
            />
            <AccessibilityElement
                onBlur={onBlur}
                onClick={onClick}
                aria-label={toggleInfo}
                className={style.actuator}
                ariaLiveLabel={afterToggleInfo}
                ariaLiveLabelPosition="outside"
                accessibilityButtons={['Enter', ' ', 'Spacebar']}
            />
        </div>
    );
};
